<div class="container">
  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 p-0 rounded">
      <div class="well p-2" >
        <form [formGroup]="frmAcesso" (ngSubmit)="onSubmit()">
          <div class="row mb-1">
            <div class="col-sm-12">
              <label for="txtCpf" class="d-inline" >CPF</label>
              <div class="input-group input-group-sm">
                <label class="input-group-text" for="txtCpf">
                  <b class="fa fa-user" aria-hidden="true"></b>
                </label>
                <input type="text" 
                       name="txtCpf" 
                       class="form-control" 
                       title="" 
                       tabindex="1"
                       maxlength="14"
                       placeholder="___.___.___-__" 
                       required
                       mask="000.000.000-00"
                       formControlName="cpf" 
                       [ngModel]="acesso.cpf | cpf"
                       (keypress)="soNumeros($event)"
                       appOnlyNumbers
                       (paste)="verificarCampoCpf(acesso.cpf)"
                       (input)="verificarCampoCpf(acesso.cpf)">
              </div>
            </div>
            <div class="text-start pb-0 mb-0" *ngIf="tipoMsgCpf != 'VALID'">
              <label class="d-inline text-danger"  *ngIf="tipoMsgCpf != 'VALID'">{{tipoMsgCpf}}</label>
            </div>
          </div>

          <div class="row mb-1" *ngIf="isCandidatoInscrito && isCampoCpfValido">
            <div class="col-sm-12">
              <label for="txtInscricao">Nº Inscrição</label>
              <div class="input-group input-group-sm">
                <label class="input-group-text" for="txtInscricao">
                  <b class="fa fa-list-ol" aria-hidden="true"></b>
                </label>
                <input type="text" 
                          id="txtInscricao" 
                          class="form-control" 
                          title=""  
                          tabindex="2"
                          maxlength="8"
                          placeholder="___-____" 
                          mask="000-0000"
                          required
                          formControlName="inscricao"
                          [ngModel]="acesso.inscricao | numeroInscricao "
                          (keypress)="soNumeros($event)"
                          appOnlyNumbers
                          (paste)="verificarCampoInscricao(acesso.inscricao)"
                          (input)="verificarCampoInscricao(acesso.inscricao)">
              </div>
            </div>
            <div class="text-start pb-0 mb-0" *ngIf="tipoMsgInscricao != 'VALID'">
              <label class="d-inline text-danger"  *ngIf="tipoMsgInscricao != 'VALID'">{{tipoMsgInscricao}}</label>
            </div>
          </div>

          <div class="row" >
            <div class="col-sm-12 mt-2 d-grid">
                <button type="submit" 
                        id="btnAvancar"  
                        class="btn btn-primary btn-sm azulTopo" 
                        [disabled]="frmAcesso.invalid">
                  Avançar
                </button>
            </div>
          </div>

        </form>

      </div>
    </div>
    <div class="col-sm-3"></div>
  </div>
  <div class="row" *ngIf="(acesso.ind_prazoConcurso != 'INICIADA' && 
                           acesso.ind_prazoConcurso != 'LIBERAR_COTISTA' && 
                           descricaoPrazoConcurso != '')">
      <div class="col-sm-3"></div>
      <div class="col-sm-6 p-0 rounded well pt-1 pb-1">
        <label id="lblPrazoConc" class="d-block text-center h6 mb-1">{{descricaoPrazoConcurso}}</label>
        <div class="col-sm-12 mt-2 d-grid p-1">
          <button class="btn btn-primary btn-sm text-center azulTopo" (click)="btnOk()">
            <i class="fa fa-check">&nbsp;Ok</i>
          </button>
        </div>
      </div>
      <div class="col-sm-3"></div>
  </div>
</div>